import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { useLingui } from '@lingui/react/macro';
import { Button } from '@riosoma/ui';
import { anchor } from '../demos/anchors';
import { shortcutKeys } from '../shortcuts/runtime';
import './PaletteButton.css';

/**
 * The header's way into the palette: the label, with the keys that do the same thing beside it, so
 * the shortcut teaches itself the first time someone reaches for the mouse.  At phone widths only
 * the icon fits, and the button keeps its name through its aria-label.
 */
export function PaletteButton({ onPress }: { onPress(): void }) {
  const { t } = useLingui();
  const label = t({ id: 'palette.open', message: 'Search' });
  return (
    <Button
      variant="quiet"
      size="sm"
      icon={faMagnifyingGlass}
      aria-label={label}
      onPress={onPress}
      primaryAction
      {...anchor('palette.open')}
    >
      <span className="rio-palette__label">{label}</span>
      <kbd className="rio-palette__keys">{shortcutKeys('palette.open')}</kbd>
    </Button>
  );
}
